<template>
<body>
  <div id="colorlib-page">
    <NavBar />

    <div id="colorlib-main">
      <section class="ftco-section ftco-no-pt ftco-no-pb">
        <div class="row d-flex no-gutters">
          <div class=" col-lg-12 px-md-5 py-5">
            <div class="row">
              <!--
              <figure class="post-full-image">
                <img :srcset="post.feature_image" sizes="(max-width: 800px) 400px,
                            (max-width: 1170px) 1170px,
                            2000px" :src="post.feature_image" />
              </figure>
              -->
              <h1 class="mb-3"> {{ post.title }} </h1>
              <div class="post-content" v-html="post.html" />

            </div>
          </div>
        </div>
      </section>
    </div>

  </div>

  <!-- loader -->
  <div id="ftco-loader" class="show fullscreen"><svg class="circular" width="48px" height="48px">
      <circle class="path-bg" cx="24" cy="24" r="22" fill="none" stroke-width="4" stroke="#eeeeee" />
      <circle class="path" cx="24" cy="24" r="22" fill="none" stroke-width="4" stroke-miterlimit="10" stroke="#F96D00" />
    </svg></div>

</body>
</template>

<script>
import NavBar from '@/components/NavBar'
import {
  getSinglePost
} from '../api/posts';

export default {
  components: {
    NavBar
  },
  data: () => ({
    post: []
  }),
  mounted() {
    this.asyncData()
  },
  methods: {
    async asyncData() {
      getSinglePost(this.$route.params.slug).then(result => {
        this.post = result
      })
    }
  },
  filters: {
    truncate: function (text, length, suffix) {
      if (text !== null) {
        return text.substring(0, length) + suffix
      }
    }
  }
}
</script>

<style lang="scss">
.post-content {
  display: inline-block;
  word-wrap: break-word;
  word-break: break-all;
  width: fit-content;
  height: fit-content;
}

.post-content .img {
  width: 100px;
}

.medium-zoom-image.medium-zoom-image--opened,
.medium-zoom-image.medium-zoom-image--hidden {
  z-index: 1200 !important;
  opacity: 1 !important;
}
</style>
